import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataCountriesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataCountries.staticDataCountriesFeatureKey]
);

export const getStaticDataCountriesFailure = createSelector(
  getStaticDataCountriesState,
  staticDataCountriesReducer.fromStaticDataCountries.getStaticDataCountriesFailure
);

export const getStaticDataCountriesResponse = createSelector(
  getStaticDataCountriesState,
  staticDataCountriesReducer.fromStaticDataCountries.getStaticDataCountriesResponse
);
